import React, { useContext } from "react";
import { CompareStickyWrapper, StickyContent, Thumbnail } from "./styles";
import { Context } from "../context";
import { GatsbyImage } from "gatsby-plugin-image";

const CompareSticky = ({ openSticky }) => {
  const { compareProducts } = useContext(Context);

  if (!compareProducts || compareProducts.length === 0) return null;

  return (
    <CompareStickyWrapper onClick={() => openSticky()} className="compare-sticky">
      <StickyContent>
        <span>Comparison</span>
        <Thumbnail>
          <GatsbyImage
            image={compareProducts[0].image.gatsbyImageData}
            alt={compareProducts[0].title}
          />
        </Thumbnail>
        <i>{compareProducts.length}</i>
      </StickyContent>
    </CompareStickyWrapper>
  );
};

export default CompareSticky;
